export enum ReleaseSystem {
    MacOsArm = "mac/arm64",
    MacOsIntel = "mac/x64",
    Windows = "windows",
    Linux = "linux",
}

export type BuildVersionByReleaseSystem = Record<ReleaseSystem, { buildVersion: string }>;
